const getters = {
  token: state => state.token
}
export default getters
